var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.518 13.39V11.64C2.096 11.472 1.06 10.142 0.948 8.378H3.02C3.118 9.19 3.412 9.848 4.518 10.016V7.314C2.292 6.964 1.228 6.152 1.228 4.304C1.228 2.694 2.516 1.504 4.518 1.364V0.118H5.512V1.378C7.416 1.546 8.564 2.498 8.732 4.304H6.73C6.604 3.576 6.254 3.128 5.512 2.988V5.494C7.612 5.816 8.9 6.516 8.9 8.462C8.9 10.142 7.724 11.486 5.512 11.64V13.39H4.518ZM6.828 8.7C6.828 8.028 6.548 7.692 5.512 7.468V10.016C6.324 9.876 6.828 9.386 6.828 8.7ZM3.244 4.122C3.244 4.766 3.482 5.116 4.518 5.326V2.96C3.692 3.072 3.244 3.534 3.244 4.122Z",
    fill: "#0A0E18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollarIcon.599a36a3f1b76012d226d7e0a2a1e08e.svg";
export { ForwardRef as ReactComponent };